import { useState, useSyncExternalStore } from "react";
import { useT } from "../lib/i18n";
import { createThemeStore } from "../lib/theme";

// Icon-only: the header keeps one brand action (Telegram) plus language.
export default function ThemeToggle() {
  const { lang } = useT();
  const [store] = useState(createThemeStore);
  const theme = useSyncExternalStore(store.subscribe, store.getSnapshot);
  const dark = theme === "dark";
  const nextLabel = lang === "tr" ? (dark ? "Açık temaya geç" : "Koyu temaya geç") : (dark ? "Switch to light theme" : "Switch to dark theme");

  return <button
    type="button"
    className="a1-icon-button"
    aria-label={nextLabel}
    title={nextLabel}
    onClick={store.toggle}
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {dark ? <><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M4.93 4.93l1.42 1.42m11.3 11.3 1.42 1.42M4.93 19.07l1.42-1.42m11.3-11.3 1.42-1.42"/></> : <path d="M20.5 13.2A8.5 8.5 0 0 1 10.8 3.5 8.5 8.5 0 1 0 20.5 13.2Z"/>}
    </svg>
  </button>;
}
